import { Component, createRef } from 'preact';
import { html } from '../../helpers/preact-html';
import { dispatchEvent } from '../../helpers/events';
import { $ } from '../../helpers/shortcuts';

import { DesktopNavigationSelector } from './DesktopNavigationSelector.component';
import { DesktopNavigationPageL1 } from './DesktopNavigationPageL1.component';
import { DesktopNavigationPageL2 } from './DesktopNavigationPageL2.component';
import { DesktopNavigationPageL3 } from './DesktopNavigationPageL3.component';
import { DesktopNavigationHeader } from './DesktopNavigationHeader.component';
import { DesktopNavigationFooter } from './DesktopNavigationFooter.component';

class DesktopNavigation extends Component {
  constructor() {
    super();
    this.refContentarea = createRef();

    this.state = {
      currentMenuLayer: 1,
      currentFirstLayerMenuItemId: null,
      currentSubmenuItemId: null,
      currentThirdLayerMenuItemId: null,
    };
    this.onSelectSubmenu = this.onSelectSubmenu.bind(this);
    this.onNavigateToFirstLayer = this.onNavigateToFirstLayer.bind(this);
    this.onCurrentFirstLayerMenuItemChangeFromOutside = this.onCurrentFirstLayerMenuItemChangeFromOutside.bind(
      this,
    );
    this.onCurrentSecondLayerMenuItemChangeFromOutside = this.onCurrentSecondLayerMenuItemChangeFromOutside.bind(
      this,
    );
  }

  componentWillMount() {
    const { navTree } = this.props;
    const $headerNavSecondary = $('.header-nav-secondary');
    const currentFirstLayerMenuItemId =
      $headerNavSecondary && $headerNavSecondary.hasAttribute('data-menuid')
        ? $headerNavSecondary.getAttribute('data-menuid')
        : navTree.items[0].id;
    this.changeMenuLayer(this.state.currentMenuLayer);
    this.setState({ currentFirstLayerMenuItemId });
    this.changeMenuLayer(1);
    document.addEventListener(
      'select-subnav',
      this.onCurrentFirstLayerMenuItemChangeFromOutside,
    );
    document.addEventListener(
      'select-subnav-L1',
      this.onCurrentSecondLayerMenuItemChangeFromOutside,
    );
  }

  componentWillUnmount() {
    document.removeEventListener(
      'select-subnav',
      this.onCurrentSecondLayerMenuItemChangeFromOutside,
    );
  }

  onCurrentFirstLayerMenuItemChange(newMenuItem) {
    this.scrollToTop();
    this.changeMenuLayer(1);
    this.setState({
      currentFirstLayerMenuItemId: newMenuItem,
      currentMenuLayer: 1,
    });
    dispatchEvent({
      eventName: 'select-subnav',
      node: document,
      detail: { menuId: newMenuItem, dispatchedBy: 'desktopNavigation' },
    });
  }

  onCurrentFirstLayerMenuItemChangeFromOutside(e) {
    if (e.detail.dispatchedBy === 'desktopNavigation') return;
    this.onCurrentFirstLayerMenuItemChange(e.detail.menuId);
  }

  onCurrentSecondLayerMenuItemChangeFromOutside(e) {
    this.changeMenuLayer(2);
    this.setState({
      currentMenuLayer: 2,
      currentFirstLayerMenuItemId: e.detail.menuId,
      currentSubmenuItemId: e.detail.menuIdL1,
    });
  }

  onSelectSubmenu(submenuId) {
    this.scrollToTop();
    const { currentMenuLayer } = this.state;
    switch (currentMenuLayer) {
      case 1:
        this.changeMenuLayer(this.state.currentMenuLayer + 1);
        this.setState({
          currentMenuLayer: this.state.currentMenuLayer + 1,
          currentSubmenuItemId: submenuId,
        });
        break;
      case 2:
        this.changeMenuLayer(this.state.currentMenuLayer + 1);
        this.setState({
          currentMenuLayer: this.state.currentMenuLayer + 1,
          currentThirdLayerMenuItemId: submenuId,
        });
        break;
      case 3:
        this.setState({
          currentThirdLayerMenuItemId: submenuId,
        });
        break;
      default:
        break;
    }
  }

  onNavigateToFirstLayer() {
    this.changeMenuLayer(1);
    this.setState({
      currentMenuLayer: 1,
    });
  }

  changeMenuLayer(newMenuLayer) {
    this.props.onMenuLayerChange({ newMenuLayer });
  }

  scrollToTop() {
    // this.refContentarea.current.scrollTo({
    //   top: 0,
    //   left: 0,
    //   behavior: 'smooth',
    // });
  }

  renderNavigationPage() {
    const {
      currentFirstLayerMenuItemId,
      currentSubmenuItemId,
      currentThirdLayerMenuItemId,
      currentMenuLayer,
    } = this.state;
    const { navTree } = this.props;

    const firstLayerMenu = navTree.items.find(
      ({ id }) => currentFirstLayerMenuItemId === id,
    );

    if (currentMenuLayer === 1) {
      return html`
        <div class="navigation-scrollwrapper">
          <${DesktopNavigationSelector}
            navTree=${navTree}
            currentItemId=${currentFirstLayerMenuItemId}
            onItemIdChange=${this.onCurrentFirstLayerMenuItemChange.bind(this)}
          />
          <${DesktopNavigationHeader} navTree=${navTree} />
          <${DesktopNavigationPageL1}
            key=${currentFirstLayerMenuItemId}
            navPage=${firstLayerMenu}
            onSelectSubmenu=${this.onSelectSubmenu}
          />
          <${DesktopNavigationFooter} navTree=${navTree} />
        </div>
      `;
    } else if (currentMenuLayer === 2 || currentMenuLayer === 3) {
      const submenu = firstLayerMenu.children.find(
        ({ id }) => currentSubmenuItemId === id,
      );

      return html`
        <${DesktopNavigationPageL2}
          key=${currentSubmenuItemId}
          currentMenuLayer=${currentMenuLayer}
          currentThirdLayerMenuItemId=${currentThirdLayerMenuItemId}
          navPage=${submenu}
          firstLayerMenu=${firstLayerMenu}
          onNavigateToFirstLayer=${this.onNavigateToFirstLayer}
          onSelectSubmenu=${this.onSelectSubmenu}
        />
      `;
    }
  }

  renderRightSide() {
    const { navTree } = this.props;
    const {
      currentMenuLayer,
      currentFirstLayerMenuItemId,
      currentSubmenuItemId,
      currentThirdLayerMenuItemId,
    } = this.state;

    const firstLayerMenu = navTree.items.find(
      ({ id }) => currentFirstLayerMenuItemId === id,
    );

    const submenuParent = firstLayerMenu.children.find(
      ({ id }) => currentSubmenuItemId === id,
    );
    const thirdLayerMenu = submenuParent.children.find(
      ({ id }) => currentThirdLayerMenuItemId === id,
    );

    if (currentMenuLayer === 3) {
      return html`
        <div class="navigation-wrapper-rightside">
          <${DesktopNavigationPageL3}
            key=${currentThirdLayerMenuItemId}
            navPage=${thirdLayerMenu}
            onNavigateToFirstLayer=${this.onNavigateToFirstLayer}
            onSelectSubmenu=${this.onSelectSubmenu}
          />
        </div>
      `;
    }
  }

  render(
    { navTree, logo, onCloseButtonClick },
    { currentFirstLayerMenuItemId, currentMenuLayer },
  ) {
    const leftSideClasses = ['navigation-wrapper-leftside'];
    currentMenuLayer > 1 &&
      leftSideClasses.push('navigation-wrapper-reducedwidth');

    return html`
      <div class=${leftSideClasses.join(' ')}>
        <a href="/" class="navigation-logo">
          <img
            src=${logo.src}
            alt=${logo.alt}
            width=${logo.width}
            height=${logo.height}
          />
        </a>
        ${this.renderNavigationPage()}
      </div>
      ${currentMenuLayer === 3 && this.renderRightSide()}
      <button
        onClick=${onCloseButtonClick && onCloseButtonClick}
        type="button"
        class="button navigation-closebutton button-icon button-tertiary button-icon-mediumicon"
        aria-label="Menü Schließen"
        data-trigger="nav"
      >
        <i class="ri-close-line" aria-label="Schließen Symbol"></i>
      </button>
    `;
  }
}

export { DesktopNavigation };
